// This file does not currently contain lots of constants, but we've disabled
// the max-len warning since we can anticipate that this file may end up
// containing lots of icon paths amongst other constants.

// contentArticle icon renders an article icon (similar to the one
// used in the content library) without the circle around it.
export const contentArticle = {
    path: `M3 3.002C3 2.45 3.451 2 3.99 2H9v4h4v7.003c0 .55-.456.997-.995.997h-8.01C3.445 14 3 13.544 3 12.998V3.002zM10 2l3 3h-3V2zM5 9.5c0 .268.22.5.491.5h5.018a.5.5 0 0 0 0-1H5.491A.5.5 0 0 0 5 9.5zm0 2c0 .268.22.5.491.5h5.018a.5.5 0 0 0 0-1H5.491a.5.5 0 0 0-.491.5z`,
    height: 16,
    width: 16,
} as const;

// contentExercise icon renders an exercise icon (similar to the one
// used in the content library) without the circle around it.
export const contentExercise = {
    path: `M8 11l-3.08 1.62c-.247.129-.41.023-.361-.263l.588-3.43-2.492-2.429c-.2-.194-.15-.383.138-.425l3.444-.5 1.54-3.12c.123-.25.318-.26.446 0l1.54 3.12 3.444.5c.276.04.346.222.138.425l-2.492 2.43.588 3.429c.048.274-.104.397-.36.262L8 11z`,
    height: 16,
    width: 16,
} as const;

// contentArticle icon renders a video/play button icon (similar to the one
// used in the content library) without the circle around it.
export const contentVideo = {
    path: `M5.555 3.17l6 4a1 1 0 0 1 0 1.664l-6 4A1 1 0 0 1 4 12.002v-8a1 1 0 0 1 1.555-.832z`,
    height: 16,
    width: 16,
} as const;

export const contentKindIconMap = {
    Article: contentArticle,
    Challenge: contentExercise,
    CourseChallenge: contentExercise,
    Exercise: contentExercise,
    Interactive: contentExercise,
    Project: contentExercise,
    Scratchpad: contentExercise,
    Talkthrough: contentExercise,
    TopicQuiz: contentExercise,
    TopicUnitTest: contentExercise,
    Video: contentVideo,
    AIGuideActivity: contentExercise,
} as const;
